var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists assessment-add-section" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c("masteradmin-sidebar-menu"),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper", attrs: { id: "top" } }, [
            _c("div", { staticClass: "container-wrapper center" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showOverlay,
                      expression: "showOverlay"
                    }
                  ],
                  staticClass: "modal-custom"
                },
                [_vm._m(0)]
              ),
              _vm._v(" "),
              _c("div", [
                _c("div", {}, [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("Edit Notification")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "d-inline btn btn-blue float-right create-btn ml-1",
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("\n              Save\n            ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "heading-seperator" }),
              _vm._v(" "),
              _c("div", { staticStyle: { clear: "both" } }),
              _vm._v(" "),
              _c("div", { staticClass: "margin-bottom-10" }),
              _vm._v(" "),
              _c("div", {}, [
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-6 override-padding float-left",
                      staticStyle: { "padding-left": "15px" }
                    },
                    [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 override-padding float-left" },
                          [
                            _c("b-form-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "input-text col-12",
                              staticStyle: { "margin-right": "15px" },
                              attrs: {
                                name: "notification_category_id",
                                options: _vm.category_options
                              },
                              model: {
                                value: _vm.notification_category_id,
                                callback: function($$v) {
                                  _vm.notification_category_id = $$v
                                },
                                expression: "notification_category_id"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 override-padding float-left" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.notification_name,
                                  expression: "notification_name"
                                }
                              ],
                              staticClass: "col-12 input-text form-control",
                              staticStyle: { "line-height": "30px" },
                              attrs: {
                                name: "notification_name",
                                placeholder: "Enter Notification Template Name",
                                maxlength: "140"
                              },
                              domProps: { value: _vm.notification_name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.notification_name = $event.target.value
                                }
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col-9 override-padding float-left",
                            attrs: { id: "mentee-group-wrapper" }
                          },
                          [
                            _c("multiselect", {
                              attrs: {
                                options: _vm.roles_options,
                                "track-by": "name",
                                label: "name",
                                placeholder: "Select Notification Role",
                                multiple: true,
                                "close-on-select": false,
                                "show-labels": false,
                                name: "roles_show",
                                id: "roles_show"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function(ref) {
                                    var values = ref.values
                                    var search = ref.search
                                    var isOpen = ref.isOpen
                                    return [
                                      values.length && !isOpen
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "multiselect__single"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(values.length) +
                                                  " selected"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.roles_selected,
                                callback: function($$v) {
                                  _vm.roles_selected = $$v
                                },
                                expression: "roles_selected"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "margin-bottom-10",
                        staticStyle: { clear: "both" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6  float-left" }, [
                    _c("div", { staticClass: "col-12 override-padding" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 override-padding float-left" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.trigger_note,
                                expression: "trigger_note"
                              }
                            ],
                            staticClass: "col-12 input-text form-control",
                            staticStyle: { "line-height": "30px" },
                            attrs: {
                              name: "trigger_note",
                              placeholder: "Enter Trigger Note",
                              maxlength: "250"
                            },
                            domProps: { value: _vm.trigger_note },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.trigger_note = $event.target.value
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "margin-bottom-10",
                      staticStyle: { clear: "both" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 override-padding" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 override-padding float-left" },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.purpose_note,
                                expression: "purpose_note"
                              }
                            ],
                            staticClass:
                              "textarea col-xs-12 col-md-12 col-lg-12 input-height-25",
                            staticStyle: { height: "90px" },
                            attrs: {
                              name: "purpose_note",
                              placeholder: "Purpose Notes",
                              maxlength: "500"
                            },
                            domProps: { value: _vm.purpose_note },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.purpose_note = $event.target.value
                              }
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { clear: "both" } })
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    { staticClass: "subtask-wrapper" },
                    [
                      _c(
                        "h4",
                        { staticClass: "panel-title" },
                        [
                          _c(
                            "b-link",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: "collapse-1",
                                  expression: "'collapse-1'"
                                }
                              ],
                              attrs: { size: "sm" }
                            },
                            [
                              _vm._v(
                                "\n                    Email Notification\n                  "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          staticClass: "mt-2 task-wrapper",
                          attrs: { id: "collapse-1" }
                        },
                        [
                          _c("b-card", { staticClass: "hidden-xs hidden-sm" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 override-padding" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-9 override-padding float-left",
                                    staticStyle: { "padding-left": "15px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding",
                                        staticStyle: { "padding-top": "7px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [
                                            _c("label", [
                                              _vm._v("Subject Line: ")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-left"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.email_subject_line,
                                                  expression:
                                                    "email_subject_line"
                                                }
                                              ],
                                              staticClass:
                                                "col-12 input-text form-control",
                                              staticStyle: {
                                                "line-height": "30px"
                                              },
                                              attrs: {
                                                name: "email_subject_line",
                                                placeholder:
                                                  "Enter Subject Line",
                                                maxlength: "250"
                                              },
                                              domProps: {
                                                value: _vm.email_subject_line
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.email_subject_line =
                                                    $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "margin-bottom": "12px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [_c("label", [_vm._v("From: ")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-left"
                                          },
                                          [
                                            _c("b-form-select", {
                                              staticClass: "input-text col-12",
                                              staticStyle: {
                                                "margin-right": "15px"
                                              },
                                              attrs: {
                                                name: "email_from",
                                                options: _vm.from_email_options
                                              },
                                              model: {
                                                value: _vm.email_from,
                                                callback: function($$v) {
                                                  _vm.email_from = $$v
                                                },
                                                expression: "email_from"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "margin-bottom": "12px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [_c("label", [_vm._v("To: ")])]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-left"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.email_to,
                                                  expression: "email_to"
                                                }
                                              ],
                                              staticClass:
                                                "col-12 input-text form-control",
                                              staticStyle: {
                                                "line-height": "30px"
                                              },
                                              attrs: {
                                                name: "email_to",
                                                id: "email_to",
                                                placeholder: "Enter To Address",
                                                maxlength: "250"
                                              },
                                              domProps: { value: _vm.email_to },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.email_to =
                                                    $event.target.value
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "margin-bottom-10",
                                      staticStyle: { clear: "both" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [
                                            _c("label", [
                                              _vm._v("Email Message: ")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-right",
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _c("label", [_vm._v("Enabled: ")]),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "switch",
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                  padding: "0"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.email_status,
                                                      expression: "email_status"
                                                    }
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.email_status
                                                    )
                                                      ? _vm._i(
                                                          _vm.email_status,
                                                          null
                                                        ) > -1
                                                      : _vm.email_status
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a =
                                                          _vm.email_status,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.email_status = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.email_status = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.email_status = $$c
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "slider round"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "margin-bottom": "0px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 override-padding email-message"
                                      },
                                      [
                                        _c("vue-editor", {
                                          ref: "textarea",
                                          attrs: {
                                            placeholder: "Enter Email Message"
                                          },
                                          on: {
                                            "text-change":
                                              _vm.emailMessageChange
                                          },
                                          model: {
                                            value: _vm.email_message,
                                            callback: function($$v) {
                                              _vm.email_message = $$v
                                            },
                                            expression: "email_message"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "character-limit" },
                                          [
                                            _c("div", {
                                              staticClass: "col-6 float-left",
                                              staticStyle: {
                                                "text-align": "left"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 float-right",
                                                staticStyle: {
                                                  "text-align": "right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Remaining: " +
                                                    _vm._s(_vm.email_count) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticStyle: { clear: "both" }
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3 float-left" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 override-padding" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticStyle: {
                                            padding: "0",
                                            "line-height": "12px"
                                          }
                                        },
                                        [_vm._v('Select "To" Email: ')]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 ",
                                      staticStyle: {
                                        "background-color": "#FFF",
                                        border: "1px  solid #242426",
                                        padding: "5px"
                                      }
                                    },
                                    _vm._l(_vm.to_email_options, function(
                                      list
                                    ) {
                                      return _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.inclToEmail(list)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(list))]
                                        )
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 override-padding",
                                      staticStyle: { "padding-top": "12px" }
                                    },
                                    [_c("label", [_vm._v("Select fields: ")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 ",
                                      staticStyle: {
                                        "background-color": "#FFF",
                                        border: "1px  solid #242426",
                                        padding: "5px",
                                        "margin-top": "1px",
                                        height: "350px",
                                        overflow: "scroll"
                                      }
                                    },
                                    _vm._l(_vm.field_options, function(list) {
                                      return _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.inclEmailMessage(
                                                  list
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(list))]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    { staticClass: "subtask-wrapper" },
                    [
                      _c(
                        "h4",
                        { staticClass: "panel-title" },
                        [
                          _c(
                            "b-link",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: "collapse-2",
                                  expression: "'collapse-2'"
                                }
                              ],
                              attrs: { size: "sm" }
                            },
                            [
                              _vm._v(
                                "\n                    SMS Notification\n                  "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          staticClass: "mt-2 task-wrapper",
                          attrs: { id: "collapse-2" }
                        },
                        [
                          _c("b-card", { staticClass: "hidden-xs hidden-sm" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 override-padding" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-9 override-padding float-left",
                                    staticStyle: { "padding-left": "15px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [
                                            _c("label", [
                                              _vm._v("SMS Message: ")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-right",
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _c("label", [_vm._v("Enabled: ")]),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "switch",
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                  padding: "0"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.sms_status,
                                                      expression: "sms_status"
                                                    }
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.sms_status
                                                    )
                                                      ? _vm._i(
                                                          _vm.sms_status,
                                                          null
                                                        ) > -1
                                                      : _vm.sms_status
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a = _vm.sms_status,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.sms_status = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.sms_status = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.sms_status = $$c
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "slider round"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "margin-bottom": "0px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.sms_message,
                                              expression: "sms_message"
                                            }
                                          ],
                                          staticClass:
                                            "textarea col-xs-12 col-md-12 col-lg-12 input-height-25",
                                          staticStyle: { height: "320px" },
                                          attrs: {
                                            name: "sms_message",
                                            id: "sms_message",
                                            placeholder: "Enter SMS Message",
                                            maxlength: _vm.sms_limit
                                          },
                                          domProps: { value: _vm.sms_message },
                                          on: {
                                            keyup: _vm.smsMessageChange,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.sms_message =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "character-limit",
                                            staticStyle: {
                                              "margin-top": "-7px"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 float-left",
                                                staticStyle: {
                                                  "text-align": "left"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Limit: " +
                                                    _vm._s(_vm.sms_limit) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 float-right",
                                                staticStyle: {
                                                  "text-align": "right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Remaining: " +
                                                    _vm._s(_vm.sms_count) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticStyle: { clear: "both" }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3 float-left" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 override-padding",
                                      staticStyle: { "padding-top": "0px" }
                                    },
                                    [_c("label", [_vm._v("Select fields: ")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 ",
                                      staticStyle: {
                                        "background-color": "#FFF",
                                        border: "1px  solid #242426",
                                        padding: "5px",
                                        "margin-top": "1px",
                                        height: "350px",
                                        overflow: "scroll"
                                      }
                                    },
                                    _vm._l(_vm.field_options, function(list) {
                                      return _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.inclSMSMessage(list)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(list))]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "margin-bottom-10",
                  staticStyle: { clear: "both" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 override-padding" }, [
                  _c(
                    "div",
                    { staticClass: "subtask-wrapper" },
                    [
                      _c(
                        "h4",
                        { staticClass: "panel-title" },
                        [
                          _c(
                            "b-link",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: "collapse-3",
                                  expression: "'collapse-3'"
                                }
                              ],
                              attrs: { size: "sm" }
                            },
                            [
                              _vm._v(
                                "\n                    Push Notification\n                  "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          staticClass: "mt-2 task-wrapper",
                          attrs: { id: "collapse-3" }
                        },
                        [
                          _c("b-card", { staticClass: "hidden-xs hidden-sm" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 override-padding" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-9 override-padding float-left",
                                    staticStyle: { "padding-left": "15px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [
                                            _c("label", [
                                              _vm._v("Push Title: ")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-10 override-padding float-right",
                                            staticStyle: {
                                              "text-align": "right"
                                            }
                                          },
                                          [
                                            _c("label", [_vm._v("Enabled: ")]),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "switch",
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                  padding: "0"
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.push_status,
                                                      expression: "push_status"
                                                    }
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.push_status
                                                    )
                                                      ? _vm._i(
                                                          _vm.push_status,
                                                          null
                                                        ) > -1
                                                      : _vm.push_status
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a = _vm.push_status,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.push_status = $$a.concat(
                                                              [$$v]
                                                            ))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.push_status = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.push_status = $$c
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "slider round"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "margin-bottom": "0px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.push_title,
                                              expression: "push_title"
                                            }
                                          ],
                                          staticClass:
                                            "textarea col-xs-12 col-md-12 col-lg-12 input-height-25",
                                          staticStyle: { height: "70px" },
                                          attrs: {
                                            name: "push_title",
                                            placeholder: "Enter Push Title",
                                            maxlength: _vm.push_title_limit
                                          },
                                          domProps: { value: _vm.push_title },
                                          on: {
                                            keyup: _vm.pushTitleChange,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.push_title =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "character-limit",
                                            staticStyle: {
                                              "margin-top": "-7px"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 float-left",
                                                staticStyle: {
                                                  "text-align": "left"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Limit: " +
                                                    _vm._s(
                                                      _vm.push_title_limit
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 float-right",
                                                staticStyle: {
                                                  "text-align": "right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Remaining: " +
                                                    _vm._s(
                                                      _vm.push_title_count
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticStyle: { clear: "both" }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding",
                                        staticStyle: { "padding-top": "10px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-2 override-padding float-left"
                                          },
                                          [
                                            _c("label", [
                                              _vm._v("Push Message: ")
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "col-10 override-padding float-right",
                                          staticStyle: { "text-align": "right" }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "margin-bottom": "0px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-12 override-padding"
                                      },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.push_message,
                                              expression: "push_message"
                                            }
                                          ],
                                          staticClass:
                                            "textarea col-xs-12 col-md-12 col-lg-12 input-height-25",
                                          staticStyle: { height: "174px" },
                                          attrs: {
                                            name: "push_message",
                                            id: "push_message",
                                            placeholder: "Enter Push Message",
                                            maxlength: _vm.push_limit
                                          },
                                          domProps: { value: _vm.push_message },
                                          on: {
                                            keyup: _vm.pushMessageChange,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.push_message =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "character-limit",
                                            staticStyle: {
                                              "margin-top": "-7px"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-6 float-left",
                                                staticStyle: {
                                                  "text-align": "left"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Limit: " +
                                                    _vm._s(_vm.push_limit) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 float-right",
                                                staticStyle: {
                                                  "text-align": "right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                              Characters Remaining: " +
                                                    _vm._s(_vm.push_count) +
                                                    "\n                            "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticStyle: { clear: "both" }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-3 float-left" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 override-padding",
                                      staticStyle: { "padding-top": "0px" }
                                    },
                                    [_c("label", [_vm._v("Select fields: ")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 ",
                                      staticStyle: {
                                        "background-color": "#FFF",
                                        border: "1px  solid #242426",
                                        padding: "5px",
                                        "margin-top": "1px",
                                        height: "350px",
                                        overflow: "scroll"
                                      }
                                    },
                                    _vm._l(_vm.field_options, function(list) {
                                      return _c("div", {}, [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.inclPushMessage(list)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(list))]
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader-img-center" }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Please wait...\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 override-padding" }, [
      _c("div", { staticClass: "subtask-wrapper" }, [
        _c("h4", { staticClass: "panel-title" }, [
          _vm._v(
            "\n                    Notification Information\n                "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 override-padding float-left" }, [
      _c("label", [_vm._v("Category: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 override-padding float-left" }, [
      _c("label", [_vm._v("Template Name: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 override-padding float-left" }, [
      _c("label", [_vm._v("Role: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 override-padding float-left" }, [
      _c("label", [_vm._v("Trigger Note: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 override-padding float-left" }, [
      _c("label", [_vm._v("Purpose Note: ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01faf7ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01faf7ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/edit_notification_manager.vue
// module id = null
// module chunks = 